import $ from 'jquery';

class TestimonialsItem {
  constructor(element) {
    this.$element = $(element);
    this.$actionToggleModal = this.$element.find('.testimonials-item-action-toggle-modal');

    this.addListeners();
  }

  addListeners() {
    this.$actionToggleModal.click(() => {
      this.$element.toggleClass('testimonials-item-state-modal-open');
    });
  }
}

class Testimonials {
  constructor(element) {
    this.$element = $(element);
    this.$actionViewAll = this.$element.find('.testimonials-action-view-all');
    this.$testimonialsItems = this.$element.find('.testimonials-item');

    this.testimonials = [];
    for (var i = 0; i < this.$testimonialsItems.length; i++) {
      let testimonialItemElement = this.$testimonialsItems[i];
      this.testimonials.push(new TestimonialsItem(testimonialItemElement));
    }

    this.addListeners();
  }

  addListeners() {
    this.$actionViewAll.click(() => {
      this.$element.addClass('testimonials-state-view-all');
    });
  }
}

$('.testimonials').each((index, element) => {
  new Testimonials(element);
});
